import { useCallback } from "react";
import Box from "@mui/material/Box";
import LockOutlined from "@mui/icons-material/LockOutlined";

import { losLocksApi } from "../../api/losLocksApi";
import { usePermissionsHook } from "../../hooks/usePermissionsHook";
import PipelineTableScreen from "./PipelineTableScreen";

// Loan Lock queue — CAPITAL MARKETS ONLY. This is the only surface where the
// trade counterparty is shown, and where locks are reviewed/confirmed (the
// drilldown never shows counterparty — see rate-locks.md). GET /pricing/all_locks
// 403s for non-capital-markets users, so we also gate the page in the FE.
// NOTE: lock-specific column defs are a follow-up — the shared PipelineTableScreen
// still renders loan-shaped columns.
const LoanLockRequestsPipelineScreen = () => {
  const { isCapitalMarkets } = usePermissionsHook();

  const fetchData = useCallback(({ onSuccessFn, onFailFn, onErrorFn }) => {
    const onError = onFailFn || onErrorFn || (() => {});
    losLocksApi
      .getAllLocks()
      .then((locks) => onSuccessFn?.(Array.isArray(locks) ? locks : []))
      .catch(onError);
  }, []);

  if (!isCapitalMarkets) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.25,
          minHeight: "60vh",
          textAlign: "center",
          color: "#64748b",
          p: 4,
        }}
      >
        <LockOutlined sx={{ fontSize: 36, color: "#94a3b8" }} />
        <Box sx={{ fontSize: 16, fontWeight: 700, color: "#0f172a" }}>
          Capital markets only
        </Box>
        <Box sx={{ fontSize: 13.5, maxWidth: 420 }}>
          The lock queue — where counterparties are entered and locks are
          confirmed — is restricted to the capital-markets team.
        </Box>
      </Box>
    );
  }

  return (
    <PipelineTableScreen
      title="Lock Queue"
      storageKeyPrefix="loan-lock-requests-pipeline"
      fetchData={fetchData}
    />
  );
};

export default LoanLockRequestsPipelineScreen;
